import {
	FETCH_LINKED_SPACES,
	type FetchLinkedSpaceAction,
} from '../../actions/fetch-linked-spaces';
import {
	FETCH_LINKED_SPACES_FAILURE,
	type FetchLinkedSpacesFailureAction,
} from '../../actions/fetch-linked-spaces-failure';
import {
	FETCH_LINKED_SPACE_SUCCESS,
	type FetchLinkedSpacesSuccessAction,
} from '../../actions/fetch-linked-spaces-success';
import type { SpacesState } from './types';

type Action =
	| FetchLinkedSpaceAction
	| FetchLinkedSpacesFailureAction
	| FetchLinkedSpacesSuccessAction;

export const defaultState: SpacesState = {
	linkedSpaces: { data: [], error: null, loading: false },
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: SpacesState = defaultState, action: Action): SpacesState => {
	switch (action.type) {
		case FETCH_LINKED_SPACES:
			return {
				...state,
				linkedSpaces: { data: [], error: null, loading: true },
			};
		case FETCH_LINKED_SPACE_SUCCESS:
			return {
				...state,
				linkedSpaces: {
					error: null,
					loading: false,
					data: action.payload.spaces,
				},
			};
		case FETCH_LINKED_SPACES_FAILURE:
			return {
				...state,
				linkedSpaces: { loading: false, data: [], error: action.payload.error },
			};
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
